import { api } from '../api';
import { ComplianceMode } from '../model/compliance/ComplianceMode';
import { PatientHealthcareProfessionalAssignRequest } from '../model/patient/patientHealthcareProfessionalAssignRequest';
import { PatientHealthcareProfessionalRevokeRequest } from '../model/patient/PatientHealthcareProfessionalRevokeRequest';

const complianceMode = import.meta.env
  .VITE_APP_COMPLIANCE_MODE as ComplianceMode;

export const healthcareProfessionalService = {
  getPatients,
  getPendingPatients,
  getPatientDetail,
  registerPatient,
  revokePatient,
};

function getPatients(
  accountId: string,
  isAuthorized: boolean,
  showActive?: boolean
) {
  return api.get(
    `/healthcareprofessional/get-patients/${accountId}/${isAuthorized}/${
      !showActive ? true : false
    }/${complianceMode}`
  );
}

function getPendingPatients(accountId: string) {
  return api.get(`/healthcareprofessional/pending-authorizations/${accountId}`);
}

function getPatientDetail(patientAccountId: string) {
  return api.get(`/healthcareprofessional/get-patient/${patientAccountId}/`);
}

function registerPatient(
  hcpAccountId: string,
  isAuthorizedByPatient: boolean,
  patientID: string
) {
  const request: PatientHealthcareProfessionalAssignRequest = {
    healthcareProfessionalAccountGuid: hcpAccountId,
    isAuthorizedByPatient,
    patientAccountGuid: patientID,
  };

  return api.post('/healthcareprofessional/register-patient', request);
}

function revokePatient(hcpAccountId: string, patientID: string) {
  const request: PatientHealthcareProfessionalRevokeRequest = {
    healthcareProfessionalAccountGuid: hcpAccountId,
    patientAccountGuid: patientID,
  };
  return api.post('/healthcareprofessional/revoke-patient', request);
}
